export const TranslateEn = {
    hello: 'hello'
};